import React, { useState } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary, Box,
  Card,
  CardContent,
  Link,
  Stack,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AddIcon from '@mui/icons-material/Add'
import { useSessionContext } from 'session'
import {
  type CommitteeBaseInformation
} from 'services'
import { accordionSummaryStyles, cardStyles, IconButtonWithTooltip } from 'components'

interface CommitteeEditProps {
  loading: boolean
  childCommittes: CommitteeBaseInformation[]
  committee: CommitteeBaseInformation
  parentCommitte: CommitteeBaseInformation
}

export const CommitteeHierarchyCard: React.FC<CommitteeEditProps> = ({ childCommittes, loading, parentCommitte, committee }) => {
  const [expanded, setExpanded] = useState(true)
  const { openNewTab } = useSessionContext()

  const handleAccordionChange = (): void => {
    setExpanded(!expanded)
  }

  const handleCreateSubcommittee = (): void => {
    if (committee?.id != null) {
      openNewTab(`/us/committee/create/${committee.id}`)
    }
  }

  const isSubcommittee = (): boolean => {
    return parentCommitte?.id != null
  }
  return (
    <Card sx={cardStyles}>
      <Accordion expanded={expanded} onChange={handleAccordionChange}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header"
                          sx={accordionSummaryStyles}>
          <div>
            <Typography variant="h6">Hierarchy</Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <CardContent>
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'} >
            {parentCommitte?.id != null &&
              <Link key={`com-${parentCommitte.id}-link`} component="button" variant="body1" underline={'hover'} onClick={() => { openNewTab(`/us/committee/edit/${parentCommitte?.id}`) }}>
                <Typography fontSize={'inherit'}>Parent Committee: {parentCommitte.id} - {parentCommitte.name}</Typography>
              </Link>}
            <Stack alignItems={'start'} width="fit-content">
              {childCommittes.length > 0 && <Typography fontSize={'inherit'}>Sub Committees:</Typography>}
              {childCommittes.sort((a, b) => a.name.localeCompare(b.name)).map((childCommitte, index) => (
              <Link key={`com-${childCommitte.id}-link`} component="button" variant="body1" underline={'hover'} onClick={() => {
                if (childCommitte?.id != null) { openNewTab(`/us/committee/edit/${childCommitte?.id}`) }
              }}
              >
                <Typography sx={{ fontSize: 'inherit' }}>
                  {`${String(childCommitte.id)} - ${childCommitte?.name}`}
                </Typography>
              </Link>
              ))}
            </Stack>
              {!isSubcommittee() &&
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
              <IconButtonWithTooltip
                  label="Create Subcommittee"
                  color="primary"
                  onClick={handleCreateSubcommittee}
                  icon={<AddIcon />}
              />
            </Box>}
            </Box>
            </CardContent>
        </AccordionDetails>
      </Accordion>
    </Card>
  )
}
